import React, { useState } from 'react'

import { apiFetch } from '../../helpers/meetings/api'

import { Modal, Form, Button, Select, Input, Alert } from 'antd'

const ModalNewPending = ({ isModalOpen, onOk, onCancel, quarterly, meetingDate, setLoadDataPending, users }) => {
    const [showAlert, setShowAlert] = React.useState(false);
    const [alertData, setAlertData] = React.useState({});

    const onFinish = async (values) => {
        if (!quarterly || !meetingDate) {
            console.log("Faltan datos");
            return
        }

        const obj = {
            method: 'POST',
            body: {
                user: values.user,
                description: values.description,
                status: values.status,
                quarterly,
                meeting_date: meetingDate,
                option: 'create_pending',
            }
        };

        const result = await apiFetch(obj);

        if (result.status === 'success') {
            setLoadDataPending(true);
            setShowAlert(true);
            setAlertData({
                message: "Proceso exitoso",
                description: "Se ha creado un pendiente correctamente.",
                type: "success"
            });

            setTimeout(() => {
                setShowAlert(false);

            }, 3000);
        } else {
            setShowAlert(true);
            setAlertData({
                message: "Error al crear la reunión",
                description: result.message || "Ha ocurrido un error al crear la reunión.",
                type: "error"
            });

            setTimeout(() => {
                setShowAlert(false);
            }, 3000);
        }
    };

    return (
        <Modal
            title="Crear un nuevo pendiente"
            open={isModalOpen}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
        >
            <Form
                name="formNewPending"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                    label=""
                    name="user"
                >
                    <Select
                        placeholder="Selecciona un usuario"
                        style={{ width: '100%' }}
                        rules={[{ required: true, message: 'Por favor selecciona un usuario' }]}
                    >
                        {users.map(user => (
                            <Select.Option key={user.id} value={user.id}>{user.fullName}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="description"
                    rules={[{ required: true, message: 'Añade una descripción' }]}
                >
                    <Input style={{ width: '100%' }} placeholder="Agregar descripcion" />
                </Form.Item>

                <Form.Item
                    label=""
                    name="status"
                >
                    <Select
                        placeholder="Selecciona el estado"
                        style={{ width: '100%' }}
                        rules={[{ required: true, message: 'Por favor selecciona un estado' }]}
                    >
                        <Select.Option value="En proceso">En proceso</Select.Option>
                        <Select.Option value="Realizado">Realizado</Select.Option>
                        <Select.Option value="No realizado">No realizado</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                        Crear pendiente
                    </Button>
                </Form.Item>
            </Form>

            {showAlert &&
                <Alert
                    message={alertData.message}
                    description={alertData.description}
                    type={alertData.type}
                    showIcon
                />
            }
        </Modal>
    )
}

export default ModalNewPending